import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import {
  GET_SINGLE_WEBHOOK_SUCCESS,
  GetMsisdnsForWebhooksAction,
  GetSingleWebhookAction,
  GetWebhookTypesAction
} from 'app/webhooks/webhooks.actions';
import { take } from 'rxjs/operators';
import { ActivatedRouteSnapshot } from '@angular/router/src/router_state';

@Injectable()
export class SingleWebhookResolver implements Resolve<any> {
  constructor(private store: Store<any>, private action$: Actions) {}

  resolve(route: ActivatedRouteSnapshot) {
    this.store.dispatch(new GetMsisdnsForWebhooksAction());
    this.store.dispatch(new GetWebhookTypesAction());
    this.store.dispatch(new GetSingleWebhookAction(route.params.id));

    return this.action$.pipe(ofType(GET_SINGLE_WEBHOOK_SUCCESS), take(1));
  }
}
